<script setup lang="ts">
import {computed} from "vue";
import {ICellRendererParams} from "ag-grid-community";

const {params} = defineProps<{ params: ICellRendererParams }>();
const fieldValue = computed(() => {
  return params.value;
});

</script>

<template>
  <div class="tempo-tooltip-content"
       v-html="fieldValue"/>
</template>
